import { Fragment } from 'react';

const CardTitle = ({ title, buttonContainer = <Fragment /> }) => {
  return (
    <div className="card-title align-items-center d-flex justify-content-between">
      {/* biome-ignore lint/a11y/noLabelWithoutControl: <explanation> */}
      <label>{title}</label> <div>{buttonContainer}</div>
    </div>
  );
};

export default CardTitle;
